import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const AffiliateDisclaimerCCD: IClientComponentDefinition = {
  name: 'affiliateDisclaimer',
  load: () => import(/* webpackChunkName: 'affiliateDisclaimer' */ './index'),
}
